import React from "react";
import AnimatedElement from "../AnimatedElement";
import video_seccion_cajeros from "../../assets/images/CajerosAutomaticos/video_cajeros_automaticos.mp4";
import cajeros1 from "../../assets/images/CajerosAutomaticos/cajeros1.png";
import cajeros2 from "../../assets/images/CajerosAutomaticos/cajeros2.png";
import cajeros3 from "../../assets/images/CajerosAutomaticos/cajeros3.png";
import img3carrousel from "../../assets/images/CajerosAutomaticos/cajerosautomaticos1.jpg";
import { useTranslation } from "react-i18next";

function SeccionCajerosAutomaticos() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <>
      {/* Sección de título montado sobre imagen */}
      <section className="pt-8 px-4 bg-white">
        <AnimatedElement>
          <div className="relative w-full mx-auto">
            {/* TÍTULO SUPERPUESTO */}
            <h1
              className="absolute top-4 left-4 md:top-8 md:left-8 text-4xl md:text-7xl font-bold text-orangeAtm z-20"
              style={{ fontFamily: "Helvetica" }}
            >
              {t("atmsSection.title")}
            </h1>

            {/* IMAGEN DE FONDO */}
            <img
              src={img3carrousel}
              alt="improving their services"
              className="rounded-xl w-full object-cover"
            />
          </div>
        </AnimatedElement>
      </section>

      {/* Sección de descripción + cajeros */}
      <section className="bg-gradient-to-b from-[#19235C] to-white py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2
            className="text-3xl md:text-6xl font-bold text-orangeAtm mb-6"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("atmsSection.discover")}
          </h2>
          <p
            className="text-sm md:text-xl text-white mb-12 w-full md:w-3/4 mx-auto"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("atmsSection.text1")}
          </p>
        </div>

        {/* Cajeros grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto">
          {/* Cajero 1 */}
          <AnimatedElement
            fromDirection="top"
            className="flex flex-col items-center text-center"
          >
            <img
              src={cajeros1}
              alt="industrial PC"
              className="w-full max-w-md rounded-lg"
            />
            <h3
              className="pt-6 text-fontWhite font-bold text-2xl md:text-3xl"
              style={{ fontFamily: "Helvetica" }}
            >
              Industrial PC
            </h3>
            <AnimatedElement fromDirection="bottom">
              <ul class="text-[#19235C] pt-4 text-xs md:text-lg text-justify px-4 md:px-0">
                <li>{t("atmsSection.textIndustrial")}</li>
                <li>CPU: Intel i5, 3.3GHz</li>
                <li>RAM: 8GB</li>
                <li>Drive: 1TB HDD</li>
                <li>Ports: COM x10, USB x14, VGA x2, RJ45 x2</li>
                <li>Ethernet: 2x10/100/1000 Mbps</li>
                <li>OS: Windows 10 IoT 64-bit</li>
                <li>
                  Display: 17" waterproof, dustproof, explosion-proof touch
                  screen
                </li>
                <li>Resolution: 1024x768, Brightness: 300 cd/m2, privacy filter</li>
              </ul>
            </AnimatedElement>
          </AnimatedElement>

          {/* Cajero 2 */}
          <AnimatedElement
            fromDirection="top"
            className="flex flex-col items-center text-center"
          >
            <img
              src={cajeros2}
              alt="Rebuilt ATM"
              className="w-full max-w-md rounded-lg"
            />
            <h3
              className="pt-6 text-fontWhite font-bold text-2xl md:text-3xl"
              style={{ fontFamily: "Helvetica" }}
            >
              {t("atmsSection.rebuilt")}
            </h3>
            <AnimatedElement fromDirection="bottom">
              <p className="text-[#19235C] pt-4 text-xs md:text-lg text-justify px-4 md:px-0">
                {t("atmsSection.textRebuilt")}
              </p>
            </AnimatedElement>
          </AnimatedElement>
        </div>
      </section>
    </>
  );
}

export default SeccionCajerosAutomaticos;
